<template>
  <div class="bgReport-ctn" :style="style">
    <!-- <div style="position: fixed;top: 10px;left: 0;z-index: 99"><button @click="refresh">refresh</button></div> -->
    <a4-horizontal title="Multi-day BG Curve" :bgm-sn-list="bgmSnList" :pda-sn-list="pdaSnList" v-if="showMultiDayMod">
      <template slot="firstRow">
        <chart-glu-table :values="allData" :diamonds="firstChartMiddleDataListWithoutNumber1" :setting="setting" :no-meal-highlight="!showMealTimeHighlight" :no-horizontal-split-line="!showHorizontalSplitLine" />
        <table-bG-mesurement :value="NumberOfBgMeasurements" :width="bgMesurementWidth"/>
      </template>
      <template slot="secondRow">
        <high-low-event-table :high-event-array="highEventArray" :low-event-array="lowEventArray" />
        <chart-pie :values="multiDayPie" :t2="multiDayPieStr" />
        <chart-bar :rect-nums="barRectNums" :true-counts="multiDayBarTrueCounts" :true-percents="multiDayBarTruePercents" :title="$t('% BGM Reading in target')" />
      </template>
    </a4-horizontal>
    <a4-horizontal title="Box Plot Graph" :bgm-sn-list="bgmSnList" :pda-sn-list="pdaSnList" v-if="showBoxPlot">
      <template slot="firstRow">
        <div class="boxPlot_firstRow--part1">
          <chart-plot :values="boxPlot" :no-horizontal-split-line="!showHorizontalSplitLine" />
        </div>
        <table-bG-mesurement :value="NumberOfBgMeasurements" :width="bgMesurementWidth" />
      </template>
      <template slot="secondRow">
        <high-low-event-table :high-event-array="highEventArray" :low-event-array="lowEventArray" />
        <chart-pie :values="multiDayPie" />
        <chart-bar :rect-nums="barRectNums" :true-counts="multiDayBarTrueCounts" :true-percents="multiDayBarTruePercents" :title="$t('% BGM Reading in target')" />
      </template>
    </a4-horizontal>
    <template v-if="showDailyBehavior">
      <a4-horizontal title="Daily behavior and BG" :bgm-sn-list="bgmSnList" :pda-sn-list="pdaSnList" :no-flex-grow="false" v-for="one in legalDailyList" :key="`dailybehaviorandbg_p_${+new Date()}_${one.date}`">
        <template slot="firstRow">
          <chart-3-line :value="one" :no-horizontal-split-line="!showHorizontalSplitLine" />
        </template>
        <template slot="secondRow">
          <high-low-event-table :high-event-array="dailyBehaviorHelperGetHighEventData(one)" :low-event-array="dailyBehaviorHelperGetLowEventData(one)" />
          <chart-pie :values="dailyBehaviorHelperGetPieData(one)" />
          <chart-bar :rect-nums="barRectNums" :true-counts="dailyBehaviorHelperGetBarCountsData(one)" :true-percents="dailyBehaviorHelperGetBarData(one)" :title="$t('% BGM Reading in target')" />
        </template>
      </a4-horizontal>
    </template>
    <template v-if="showBGDailyGraph">
     <a4-horizontal :first-row-no-margin-top="false" title="BG Daily Graph" :bgm-sn-list="bgmSnList" :pda-sn-list="pdaSnList" v-for="(oneDayList, pageI) in bgDailyTables" :less-pad="isLongLanguage" :no-flex-grow="true" :key="`bgdailygraph_p${pageI}_${+new Date()}`">
        <template slot="firstRow">
          <chart-glu-daily-table :values="dailyBGGraphHelperGetTableData(oneDayList)" :show-sum="pageI + 1 === bgDailyTables.length" :sum-row="bgDailyTableSummary" :sum-value="sumValue" />
        </template>
      </a4-horizontal>
    </template>
  </div>
</template>
<script>
import A4Horizontal from '@c/A4Horizontal'
import ChartBar from '@c/ChartBar'
import highLowEventTable from '@c/highLowEventTable'
import ChartPie from '@c/ChartPie'
import ChartPlot from '@c/ChartPlot'
import Chart3Line from '@c/Chart3Line'
import ChartGluTable from '@c/ChartGluTable'
import ChartGluDailyTable from '@c/ChartGluDailyTable'
// import ChartMultiDailyPump from '@c/ChartMultiDailyPump'
// import ChartDailyPump from '@c/ChartDailyPump'
import TableBGMesurement from '@c/TableBGMesurement'
import reDrawTrigger from '@mx/reDrawTrigger'
import printMixin from '@mx/print'
import bgExclusiveMixin from './bgExclusiveMixin'
import pageTitleMixin from '@mx/pageTitle'
import { bgApi } from '@u/api'
import dayjs from 'dayjs'
import { isHighGlu, isLowGlu, isNormalGlu, qcopy } from '@u'
import { _legalDataReadingsInTargetChart, _legalDataDailyListOneDataDoNotUsedInComputed, _bgSortOriginDataByDayList } from '@u/reportHelper'
// import { errorFactory, derrorFactory, dlogFactory } from '@u/log'
// const error = errorFactory('Bg.vue', false)
// const derror = derrorFactory('Bg.vue', false)
// const log = dlogFactory('Bg.vue', false)
import { derrorFactory, errorFactory } from '@u/log'
import { _legalEventArray } from './bgExclusiveMixinUtil'

const derror = derrorFactory('Bg.vue', false)
const error = errorFactory('Bg.vue', false)

function _getTablesDataFromDailyList(_list = []) {
  // derror(`_getTablesDataFromDailyList, list`, list)
  const list = _list.slice()
  const max = 14 // 一页，最多14天的数据  
  const l = list.length
  
  const pagesNum = Math.ceil(l / 14)
  const rst = []
  
  for (let i = 0; i < pagesNum; i++) {
    // one page
    const onePage = []
    const leftCount = Math.min((l - i * max), max)
    
    for (let j = 0; j < leftCount; j++) {
      const tmp = qcopy(list[i * max + j])
      if (!tmp) {
        error(`_getTablesDataFromDailyList生成BG Daily Graph数据出错。page i: ${i}, record j: ${j}, max: ${max}, 计算后的index: ${i * max + j}, 而数据源里头(共${l}条记录)这个index上没有数据;`, list)
      } else {
        onePage.push(tmp)        
      }
    }
    
    rst.push(onePage)
  }
  
  derror(`_getTablesDataFromDailyList, rst`, rst)
  return rst
}

export default {
  name: 'BgReport',
  mixins: [printMixin, reDrawTrigger, pageTitleMixin, bgExclusiveMixin],
  components: {
    A4Horizontal,
    highLowEventTable,
    ChartBar,
    ChartPie,
    ChartPlot,
    Chart3Line,
    ChartGluTable,
    ChartGluDailyTable,
    // ChartMultiDailyPump,
    // ChartDailyPump,
    TableBGMesurement
  },
  beforeCreate() {
    const $loading = this.$loading({ fullscreen: true })
    
    // const fmt = 'YYYY-MM-DD HH:mm:ssZZ'
    const fmt = 'YYYY-MM-DD'
    const p = Object.assign({}, window._query)
    p.unit = `${p.unit}` === 'mg' ? 1 : 0
    p.timeZone = p.tz
    if (!/\+/.test(p.bgnTime)) {
      p.bgnTime = dayjs(p.bgnTime).format(fmt)      
    }
    if (!/\+/.test(p.endTime)) {
      // p.endTime = dayjs(p.endTime).startOf('day').add(1, 'day').format(fmt)
      p.endTime = dayjs(p.endTime).format(fmt)
    }
    Object.assign(this, {
      _bgnTime: p.bgnTime,
      _endTime: p.endTime
    })
    
    bgApi.getBgReport(p).then((res) => {
      const { data, status } = res
      
      $loading.close()
      this.$nextTick(() => {
        this.loadingInstance = $loading
      })
      
      if (`${status}` === '200') {
        const { code, msg } = data
        
        if (`${code}` !== '200') {
          // 接口报错
          const tip = msg || `server error`
          this.$message.error(this.$t(`${tip}`))
        } else {
          // 接口成功
          const uiDataUpdate = {} // 最后将这个uiDataUpdate通过Object.assign(this, uiDataUpdate)绑定到this上，从而触发数据变化->ui变化
          const d = data.data || {}
          const bgAjaxKeys = ['patientInfo', 'allData', 'bgmSn', 'pdaSn', 'firstChartMiddleDataList', 'multiDay', 'insulinMean', 'boxPlot', 'setting', 'dailyList']
          const bgRstAssignToThis = {}
          bgAjaxKeys.forEach(k => {
            bgRstAssignToThis[k] = d[k]
          })
          
          const { allData = [], patientInfo = {}, insulinMean = {}, dailyList = [], bgmSn = [], pdaSn = [], multiDay = {}} = d
          const { NumberOfBgMeasurements = {}} = multiDay

          Object.assign(uiDataUpdate, bgRstAssignToThis, {
            NumberOfBgMeasurements,
            bgmSnList: bgmSn.filter(v => !!v), pdaSnList: pdaSn.filter(v => !!v)
          })
          uiDataUpdate.legalDailyList = dailyList ? dailyList.filter(_legalDataDailyListOneDataDoNotUsedInComputed) : []
          uiDataUpdate.bgDailyTables = _getTablesDataFromDailyList(dailyList)
          const { BgEventArray = {}, insulinChart = {}, readingsInTargetChart = {}} = multiDay
          // High glu event && Low glu event
          const { highArray = [], lowArray = [] } = BgEventArray
          uiDataUpdate.highEventArray = _legalEventArray(highArray)
          uiDataUpdate.lowEventArray = _legalEventArray(lowArray)
          
          // chart pie
          if (insulinChart && insulinChart.totalBolus !== undefined && insulinChart.totalBasal !== undefined) {
            const _basal = `${insulinChart.totalBasal}`
            const _bolus = `${insulinChart.totalBolus}`
            const days = this.assessmentTimeDaysNum || 1
            
            uiDataUpdate.multiDayPieStr = insulinMean ? `(${insulinMean})` : ''
            uiDataUpdate.multiDayPie = [{
              value: (_basal / days).toFixed(1),
              name: 'Basal Rate'
            }, {
              value: (_bolus / days).toFixed(1),
              name: 'Bolus'
            }] 
          }
          
          // chart bar
          if (readingsInTargetChart) {
            if (_legalDataReadingsInTargetChart(readingsInTargetChart)) {
              const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
              uiDataUpdate.multiDayBarTruePercents = [+veryLow.percent, +low.percent, +target.percent, +high.percent, +veryhigh.percent]
              uiDataUpdate.multiDayBarTrueCounts = [+veryLow.value, +low.value, +target.value, +high.value, +veryhigh.value]
            }
          }
          
          // 高低血糖
          const { highLimit, lowLimit, patientName } = patientInfo          
          
          if (patientName) {
            this.$store.dispatch('redraw/updateName', patientName)
          }
          this.$store.dispatch('redraw/updateHighAndLowLimit', {
            high: highLimit,
            low: lowLimit
          })
          
          // 有数据了，触发redraw
          this.$store.dispatch('redraw/notifyReDraw')
          
          // if (`${highLimit}` !== '10' || `${lowLimit}` !== '3.9') {
          //   // 该用户不是默认值的高低血糖值
          //   // 需要触发redraw
          //   // 有需要更新的,通知ui进行重新渲染
          // }
          Object.assign(this, uiDataUpdate) // 触发ui变化
        }
      }
    })
  },
  data() {
    return {
      // style: {
      //   height: (5 * 21 - 0.1) + 'cm'
      // },
      pageTitleMixinNeedTitle: 'BG Report',
      mods: 63, // (6位)二进制表示为: 111111;从右到左，各个位分别表示: Multi-day BG Curve、Box Plot Graph、Daily behavior and BG、BG Daily Graph、是否显示分割线、是否显示高亮三餐
      loadingInstance: null,
      allData: [],
      bgmSnList: [],
      pdaSnList: [],
      dailyList: [],
      multiDay: {},
      NumberOfBgMeasurements: {},
      setting: {}, // 早餐、午餐、晚餐设置的时间
      multiDayPie: [],
      multiDayPieStr: '',
      multiDayBarTruePercents: [],
      multiDayBarTrueCounts: [],
    }
  },
  // beforeCreate(v1, v2) {
  //   const { query } = this.$route || {}    
  // },
  created() {
    // 获取显示模块
    this.processMods()
    
    this.processUnitAndLangAndHour(true) // 入参true, 意味者当前是init
  },
  mounted() {
  },
  computed: {
    // legalDailyList() {
    //   const { dailyList = [] } = this
    //   return dailyList.filter(_legalDataDailyListOneData)
    // },
    style() {
      const rst = {}
      const offset = 0.15 // 每满5页，减少0.1cm; 做了个试验，如果总共6页，那么这个减少的0.1cm不够，从而会最后有一页空白；如果是5页，那么这个减少的0.1cm够用，不会最后多打印一页空白的页面
      
      const bodyR = this.body21CmRatio
      // const h = (pagesNum * 21 - offset * (Math.ceil(pagesNum / 5)))
      // rst.height = h + 'cm'
      rst.zoom = bodyR
      return rst
    },
    barRectNums() {
      const rst = [54, 70, 180, 250] // 单位是mg/dL时候的值
      const { unit } = this
      
      if (`${unit}`.trim().toLowerCase() !== 'mg/dl') { // mmol/l
        return rst.map(v => +((v / 18).toFixed(1)))
      }
      
      return rst // mg/dL
    },
    showMultiDayMod() {
      const bits = +this.mods
      
      return !!(bits & 0b000001)
    },
    showBoxPlot() {
      const bits = +this.mods
      
      return !!(bits & 0b000010)
    },
    showDailyBehavior() {
      const bits = +this.mods
      
      return !!(bits & 0b000100)
    },
    showBGDailyGraph() {
      const bits = +this.mods
      
      return !!(bits & 0b001000)
    },
    showHorizontalSplitLine() { // mods,默认不显示split line
      const bits = +this.mods
      
      return !!(bits & 0b010000)
    },
    showMealTimeHighlight() {
      const bits = +this.mods

      return !!(bits & 0b100000)
    }
  },
  methods: {
    dailyBehaviorHelperGetBarCountsData(data = {}) {
      const { threeChartData = {}} = data
      const { readingsInTargetChart } = threeChartData
      
      let rst = []
      
      if (readingsInTargetChart) {
        if (_legalDataReadingsInTargetChart(readingsInTargetChart)) {
          const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
          rst = [+veryLow.value, +low.value, +target.value, +high.value, +veryhigh.value]
        }
      }
      
      return rst
    },
    dailyBehaviorHelperGetBarData(data = {}) {
      // derror(`dailyBehaviorHelperGetBarData`)
      const { threeChartData = {}} = data
      const { readingsInTargetChart } = threeChartData

      let rst = []
      
      if (readingsInTargetChart) {
        if (_legalDataReadingsInTargetChart(readingsInTargetChart)) {
          const { veryLow, veryhigh, high, low, target } = readingsInTargetChart
          rst = [+veryLow.percent, +low.percent, +target.percent, +high.percent, +veryhigh.percent]
        }
      }

      return rst
    },
    processUnitAndLangAndHour(justInit = false) {
      const _uiNeedUpdate = {
        unit: false,
        lang: false,
        hour24: false
      }
      
      // step1, 判断语言是否need upate
      const _dl = process.env.VUE_APP_I18N_LOCALE || 'en' // default locale
      let nLocale = this.$route.query.lang || _dl // 切语言
      
      const { locale: oldLocale } = this.$i18n
      
      if (`${oldLocale}` !== `${nLocale}`) {
        _uiNeedUpdate.lang = true
      }
      
      // step2, 判断unit是否更新，默认使用单位是 'mmol/l'
      const _du = 'mmol/L'
      const nU = this.$route.query.unit ? `${this.$route.query.unit}`.trim() : _du
      const { unit: oU } = this
      
      if (`${nU}`.trim().toLowerCase() !== `${oU}`.trim().toLowerCase()) {
        _uiNeedUpdate.unit = true
      }
      
      // step3, 判断是否更新时间制，默认使用24小时制
      const _dHour = 24
      const nHour = this.$route.query.hour ? `${this.$route.query.hour}`.trim() : _dHour
      const { hourFormat: oHour } = this
      
      if (+nHour && +nHour !== +oHour) {
        _uiNeedUpdate.hour24 = true
      }
      
      if (_uiNeedUpdate.lang) { // 切语言的逻辑
        // 切语言; dayjs的语言切换，已经在main.js里头设置了
        if (`${nLocale}`.toLowerCase() === 'polish') {
          error(`语言参数，波兰语要传值pl, 不能传值polish;但我目前是支持polish的`)
          nLocale = 'pl'
        }
        
        this.$store.dispatch('redraw/updateLang', nLocale) // 这个dispatch之后的逻辑需要TBC,tbc,mock,dev
        
        // 手动切$i18n的语言库
        this.$i18n.locale = nLocale
        
        // TBC, tbc, dev: 需要切换dayjs的语言库，这个可以放到dispatch之后的逻辑里头?        
      }
      
      if (_uiNeedUpdate.unit) { // 切unit的逻辑;tbc,TBC
        this.$store.dispatch('redraw/updateUnit', nU)
      }
      
      if (_uiNeedUpdate.hour24) { // 切24小时制的逻辑;tbc,TBC
        this.$store.dispatch('redraw/updateHourformat', nHour)
      }

      console.error(`[processUnitAndLangAndHour], justInit: ${justInit}, _uiNeedUpdate: ${JSON.stringify(_uiNeedUpdate)}`)
      
      if (!justInit) {
        if (!Object.keys(_uiNeedUpdate).every(v => !!v === false)) {
          console.error(`[processUnitAndLangAndHour]触发redraw/notifyReDraw,从而让页面上的图表重新绘画`)
          // 有需要更新的,通知ui进行重新渲染
          this.$store.dispatch('redraw/notifyReDraw')
        }     
      }

      return _uiNeedUpdate
    },
    processMods() {
      const _dMods = 63 // (6位)二进制表示为: 111111;从右到左，各个位分别表示: Multi-day BG Curve、Box Plot Graph、Daily behavior and BG、BG Daily Graph、是否显示分割线、是否显示高亮三餐
      const mods = this.$route.query.mods ? +`${this.$route.query.mods}` : _dMods

      // 具体逻辑(do action)
      this.mods = mods
    }
  }
}
</script>
<style lang="scss" scoped>
/*设置默认横向打印*/
@page {
    size: A4 landscape;
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    margin-bottom: 0;
}
.bgReport-ctn {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    color-adjust: exact;
    /* display: flex; */
    /* 上面的display:flex,会影响break-before:page或者类似的功能，从而导致pdf生成的时候会坍塌*/
    /* flex-direction: column; */
    /* height: 83.888cm; // tbc,dev: 要根据实际的页数进行调整。21cm * 4页，再小一点，然后通过overflow:hidden，从而使得第五页(也即是空白页消失) */
}
@media print {
    .bgReport-ctn {
        overflow: hidden;
        zoom: 1 !important;
    }
}
.line {
    height: 1px;
    background-color: white;
}
</style>
